import { Component, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { ReportService } from "../../reportService";
import { AppMainComponent } from "src/app/app.main.component";
import { AppMainService } from "src/app/app-main.service";
import { DataService } from "../../dataService";
import { LocalDatePipe } from "src/app/shared/pipes/local-date.pipe";
import { Subscription, Subject } from 'rxjs';
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from 'rxjs/operators';
import { ReportsUserActivityRoutes } from "../../models/reports-activity.enums";
import { IReportsColumnModel } from "../../models/reports.models";
import { IReportsFilterModel } from "../../models/reports-filter.models";
import { ParseHelper } from "src/app/modules/shared/parse.helper";

@Component({
    selector: 'app-report-user-activity',
    templateUrl: './reports-user-activity.component.html',
})

export class ReportsUserActivityComponent implements OnInit,OnDestroy {

    //#region Properties
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    public selectedWindow: string = '';
    public reportName: string = '';
    public organizationName = "";
    public dateFrom: any;
    public dateTo: any;
    public reportDate: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public selectedOppStageFilter = { name: "All", id: 0 };
    public selectedDateQuestionChannelfilter = { name: "All", id: 0 };
    public selectedDateCasesChannelfilter = { name: "All", id: 0 };
    public selectedDatePipelineFilter = { name: "All", id: 0 };
    public filterByInputValue: any[] = [];

    public cols: IReportsColumnModel[] = [];
    public tableCols: IReportsColumnModel[] = [];
    public reportsData = [];
    public reportsDataCopy = [];

    public showRows: number = 15;
    public pageSize = 15;
    public pageNumber = 0;
    first = 0;
    tableShowMore: number[] = null;

    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private dataService: DataService,
        public localDatePipe: LocalDatePipe,
        private router: ActivatedRoute

    ) {}

    ngOnInit(): void {
        this.dateFrom = new Date();
        this.dateTo = new Date();

        this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
            const activityType = param.params.type;
            switch (activityType) {
                case ReportsUserActivityRoutes.userActivityByUsers:
                    this.selectedWindow = "userActivityByUsers";
                    this.reportName = 'User Activity by Users';
                    break;
                case ReportsUserActivityRoutes.userActivityByDate:
                    this.selectedWindow = "userActivityByDate";
                    this.reportName = 'User Activity by Date';
                    break;
                case ReportsUserActivityRoutes.userActivityByActivityType:
                    this.selectedWindow = "userActivityByActivityType";
                    this.reportName = 'User Activity by Activity Type';
                    break;
                default:
                    break;
            }
            this.LoginReport();
        });
        
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.LoginReport();
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    settableCols(): void {
        switch (this.selectedWindow) {
            case "userActivityByUsers": {
                this.cols = [
                    { id: 2, field: 'createdBy', header: 'Created By', dataType: "string" },
                    { id: 3, field: 'createDate', header: 'Created Date', dataType: "datetime" },
                    { id: 5, field: 'activityType', header: 'Activity type', dataType: "string" },
                    { id: 6, field: 'accountId', header: 'Account ID', dataType: "string" },
                    { id: 7, field: 'accountName', header: 'Account Name', dataType: "string" },
                    { id: 8, field: 'address', header: 'Address (Default billing)', dataType: "string" },
                    { id: 9, field: 'comment', header: 'Comment', dataType: "string" },
                ];
                this.reportsData = [
                    {
                        id:1,
                        userName:"Andrew",
                        createdBy:"User 1",
                        createDate:new Date(),
                        activityType:"Type 1",
                        accountId:"AC237891",
                        accountName:"ABC Wireless",
                        address:"23 Northland Way, FL",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment.",
                    },
                    {
                        id:2,
                        userName:"Andrew",
                        createdBy:"User 2",
                        createDate:new Date(),
                        activityType:"Type 2",
                        accountId:"AC879812",
                        accountName:"Bank of America",
                        address:"109 Ink Blvd, CA",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment.",
                    },
                    {
                        id:3,
                        userName:"Mark",
                        createdBy:"User 3",
                        createDate:new Date(),
                        activityType:"Type 3",
                        accountId:"AC027642",
                        accountName:"Test 3",
                        address:"109 Ink Blvd, CA",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment. 333333",
                    },
                ]
                break;
            }
            case "userActivityByDate": {
                this.cols = [
                    { id: 1, field: 'createDate', header: 'Created Date', dataType: "datetime" },
                    { id: 2, field: 'createdBy', header: 'Created By', dataType: "string" },
                    { id: 3, field: 'activityType', header: 'Activity type', dataType: "string" },
                    { id: 4, field: 'accountId', header: 'Account ID', dataType: "string" },
                    { id: 5, field: 'accountName', header: 'Account Name', dataType: "string" },
                    { id: 6, field: 'address', header: 'Address (Default billing)', dataType: "string" },
                    { id: 7, field: 'comment', header: 'Comment', dataType: "string" },
                ];
                this.reportsData = [
                    {
                        id:1,
                        userName:"Andrew",
                        createdBy:"User 1",
                        createDate:new Date(),
                        activityType:"Type 1",
                        accountId:"AC237891",
                        accountName:"ABC Wireless",
                        address:"23 Northland Way, FL",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment.",
                    },
                    {
                        id:2,
                        userName:"Andrew",
                        createdBy:"User 2",
                        createDate:new Date(),
                        activityType:"Type 2",
                        accountId:"AC879812",
                        accountName:"Bank of America",
                        address:"109 Ink Blvd, CA",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment.",
                    },
                    {
                        id:3,
                        userName:"Mark",
                        createdBy:"User 3",
                        createDate:new Date(),
                        activityType:"Type 3",
                        accountId:"AC027642",
                        accountName:"Test 3",
                        address:"109 Ink Blvd, CA",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment. 333333",
                    },
                ]
                break;
            }
            case "userActivityByActivityType": {
                this.cols = [
                    { id: 1, field: 'activityType', header: 'Activity type', dataType: "string" },
                    { id: 2, field: 'createDate', header: 'Created Date', dataType: "datetime" },
                    { id: 3, field: 'createdBy', header: 'Created By', dataType: "string" },
                    { id: 4, field: 'accountId', header: 'Account ID', dataType: "string" },
                    { id: 5, field: 'accountName', header: 'Account Name', dataType: "string" },
                    { id: 6, field: 'address', header: 'Address (Default billing)', dataType: "string" },
                    { id: 7, field: 'comment', header: 'Comment', dataType: "string" },
                ];
                this.reportsData = [
                    {
                        id:1,
                        userName:"Andrew",
                        createdBy:"User 1",
                        createDate:new Date(),
                        activityType:"Type 1",
                        accountId:"AC237891",
                        accountName:"ABC Wireless",
                        address:"23 Northland Way, FL",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment.",
                    },
                    {
                        id:2,
                        userName:"Andrew",
                        createdBy:"User 2",
                        createDate:new Date(),
                        activityType:"Type 2",
                        accountId:"AC879812",
                        accountName:"Bank of America",
                        address:"109 Ink Blvd, CA",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment.",
                    },
                    {
                        id:3,
                        userName:"Mark",
                        createdBy:"User 3",
                        createDate:new Date(),
                        activityType:"Type 3",
                        accountId:"AC027642",
                        accountName:"Test 3",
                        address:"109 Ink Blvd, CA",
                        comment:"test for long comment. test for long comment. test for long comment. test for long comment. 333333",
                    },
                ]
                break;
            }
            default: {
                break;
            }
        }
    }
    setFilterValues(): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case "userDeviceInfo":
                this.filterByInputValue = [...this.reportsData];
                break;
            default:
                this.filterByInputValue = [...this.reportsData];
                break;
        }
    }
    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }
    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.reportsData = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            selectedFilters?.forEach(filt => {

                let field: any = this.cols.find(f => f.field == filt.field);
                if (field?.dataType == "date") {
                    this.reportsData = this.reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                }
                else {
                    this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                }
            });
        }
        this.setFilterValues();
    }
    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        let reportsData: any[] = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            selectedFilters?.forEach(filt => {

                let field: any = this.cols.find(f => f.field == filt.field);
                if (field?.dataType == "date") {
                    reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                }
                else {
                    reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                }
            });
        }
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case "userDeviceInfo":
                this.filterByInputValue = [...reportsData];
                break;
            default:
                this.filterByInputValue = [...reportsData];
                break;
        }
    }
    onClosePanel(selectedWindow: string): void {
        //this.DownloadReport(selectedWindow);
    }
    onChangeRange(selectedWindow: string, event: any): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        //this.selectedDateFilter = event;
        const selectedUser = this.selectedRepFilter;
        this.LoginReport();
    }
    LoginReport(){
        this.organizationName = this.app.user.organizationName;
        this.settableCols();
        this.setFilterValues();
    }


}